export const PROTOCOLS_CSV = ["IPSEC", "HTTPS", "HTTPS, IPSEC"];
